import { createAsyncThunk } from '@reduxjs/toolkit';
import statisticApi from '~/apis/statistics';
import { IQueryParamBase } from '~/utils/interface/common';
import {
  STATISTIC_DAILY_LOADING,
  STATISTIC_DASHBOARD_OVERVIEW,
  STATISTIC_FOREMAN_PERFORMANCE,
  STATISTIC_ORDER_DEPOSIT_NOT_REQUIRED,
  STATISTIC_ORDER_UNPAID_DEPOSIT,
  STATISTIC_OUTSTANDING_SITE_VISIT,
  STATISTIC_OVERBOOKING_ITEM,
  STATISTIC_QUOTE_CONVERTED,
  STATISTIC_TODAY_SCHEDULE,
  STATISTIC_TODAY_TASK,
} from '~/utils/constants/actionType';
import { IQueryParamDailyLoading } from '~/utils/interface/statistic';

export const getStatisticTodayTask = createAsyncThunk(
  STATISTIC_TODAY_TASK,
  async (params: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await statisticApi.getStatisticTodayTask(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStatisticTodaySchedule = createAsyncThunk(
  STATISTIC_TODAY_SCHEDULE,
  async (params: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await statisticApi.getStatisticTodaySchedule(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStatisticOutstandingSiteVisit = createAsyncThunk(
  STATISTIC_OUTSTANDING_SITE_VISIT,
  async (params: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await statisticApi.getStatisticOutstandingSiteVisit(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStatisticQuoteConverted = createAsyncThunk(
  STATISTIC_QUOTE_CONVERTED,
  async (_, { rejectWithValue }) => {
    try {
      const resp = await statisticApi.getStatisticQuoteConverted();
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStatisticOverbookingItem = createAsyncThunk(
  STATISTIC_OVERBOOKING_ITEM,
  async (_, { rejectWithValue }) => {
    try {
      const resp = await statisticApi.getStatisticOverbookingItem();
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStatisticDashboardOverview = createAsyncThunk(
  STATISTIC_DASHBOARD_OVERVIEW,
  async (type: string, { rejectWithValue }) => {
    try {
      const resp = await statisticApi.getStatisticDashboardOverview(type);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStatisticOrderUnpaidDeposit = createAsyncThunk(
  STATISTIC_ORDER_UNPAID_DEPOSIT,
  async (params: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await statisticApi.getStatisticOrderUnpaidDeposit(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStatisticOrderDepositNotRequired = createAsyncThunk(
  STATISTIC_ORDER_DEPOSIT_NOT_REQUIRED,
  async (params: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await statisticApi.getStatisticOrderDepositNotRequired(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStatisticForemanPerformance = createAsyncThunk(
  STATISTIC_FOREMAN_PERFORMANCE,
  async (params: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await statisticApi.getStatisticForemanPerformance(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStatisticDailyLoading = createAsyncThunk(
  STATISTIC_DAILY_LOADING,
  async (params: IQueryParamDailyLoading, { rejectWithValue }) => {
    try {
      const resp = await statisticApi.getStatisticDailyLoading(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
